// @flow

import $ from "../vendor/jquery";

// Global grobot objects
import {menu_translate, clear_old_page} from "./Global";
import {activateMenuItem, jsonAjax} from "../util";
import AppConfig from "../config";
import Legacy from "../Legacy";

class Alarms {
    /**
     * @type {?Alarms}
     */
    static alarmsInstance = null;

    /**
     * @returns {Alarms}
     */
    static getInstance() {
        if (Alarms.alarmsInstance == null) Alarms.alarmsInstance = new Alarms();
        return Alarms.alarmsInstance;
    }

    constructor() {
        this.conf_errors_url = AppConfig.BASE_URL + "/errors";
    }

    load_errors() {
        let wurl = this.conf_errors_url;
        Legacy.debug("loading errors " + wurl);
        jsonAjax({
            type: "GET",
            url: wurl,
            success: function (data) {
                this.errorscall(data);
            }.bind(this)
        });
    }

    errorscall(data) {
        Legacy.debug("errorscall called");
        let errors_data = [];
        if (!data) {
            this.draw_alarms_page([]);
            return;
        }
        let l = data["errorsResult"];
        Legacy.debug(l);
        if (!l) {
            this.draw_alarms_page([]);
            return;
        }
        for (let i = 0; i < l.length; i++) {
            if (!l[i]) continue;
            errors_data.push(l[i]);
        }
        Legacy.debug("errors_data : ");
        Legacy.debug(errors_data);
        this.draw_alarms_page(errors_data);
    }

    make_alarms_page() {
        menu_translate();
        clear_old_page();
        activateMenuItem("alarms");
        Legacy.debug("alarms page being created");

        let s = "<div style='margin-left: 60px; height: 800px; overflow-y: scroll'>";
        s += "</div>";
        $("#content").html(s);
        this.load_errors();
    }

    draw_alarms_page(errors) {
        let s = "<div style='margin-left: 60px; height: 800px; overflow-y: scroll'>";
        if (!errors || errors == []) {
            s += "Vigu ei ole esinenud.";
        } else {
            errors.sort();
            errors.reverse();
            for (let i = 0; i < errors.length; i++) {
                if (!errors[i]) continue;
                s += this.process_errstr(errors[i]) + "<br>";
            }
        }
        s += "</div>";
        $("#content").html(s);
    }

    process_errstr(s) {
        if (!s) return s;
        let j = s.indexOf("]");
        if (j <= 0 || s.length < 21) {
            return s.replace("/", "//");
        } else {
            let p1 = s.substring(1, 20);
            p1 = p1.replace("T", " ");
            p1 = p1.replace("/", "//");
            let p2 = s.substring(j + 1);
            s = p1 + " " + p2;
        }
        return s;
    }
}

export default Alarms;
